import React, { useEffect, useRef, useState } from 'react'
import { PageTitle } from '../../../../_metronic/layout/core'
import { CaptableManagementBreadCrumbs } from '../core/_constants'
import searchIcon from '../../../../_metronic/assets/images/svg/data-room/search-icon-grey.svg'
import { useIntl } from 'react-intl'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import threeDots from '../../../../_metronic/assets/images/svg/investor/threeDots.svg'
import { DataTableServerSideCaptable } from '../components/DataTableServerSideCaptable'
import FundingDropdown from '../components/FundingDropdown'
import { useAuth } from '../../auth'
import { getCaptable, getSliderData } from '../core/_requests'
import brandingConfig from '../../../../config/brandingConfig'
import { NoDataPage } from '../../resources/components/NoDataPage'
// import { toast } from 'react-toastify'
import FundingSlider from '../components/FundingSlider'
import FundingSliderSkeleton from '../components/FundingSliderSkeleton'
import FundingDropdownSkeleton from '../components/FundingDropdownSkeleton'
import { CaptableSkeleton } from '../components/CaptableSkeleton'

interface Captable {
  id: number
  shareholderId: string
  shareholdings: string
  security_class: any[]
  fully_diluted_shares: number
  ownership: string
  profileImage: {
    id: string
    name: string
  } | null
  amount_invested: number
  shareTransations: any[]
  totalTransation: number
  captableLoading: boolean
}

const CaptableManagement = () => {
  const sliderValueRef = useRef<number>(1)
  const { formatMessage } = useIntl()
  const { companyId } = useAuth()
  const [search, setSearch] = useState('')
  const [showKebabMenu, setShowKebabMenu] = useState(false)
  const dropdownRef = useRef<HTMLDivElement | null>(null)
  const [shareholders, setShareholders] = useState<Captable[]>()
  // const [sliderLoading, setSliderLoading] = useState(false)
  const [captableLoading, setCaptableLoading] = useState(false) //eslint-disable-line
  const [isLoading, setIsLoading] = useState(false)
  const [subtotals, setSubtotals] = useState({
    totalFullyDilutedShares: 0,
    totalAmountInvested: 0,
    totalTransactionCount: 0,
  })
  const [sliderData, setSliderData] = useState<any[]>([])
  const [classIds, setClassIds] = useState<string[]>([])
  const [scenarioIds, setScenarioIds] = useState<string[]>([])
  const handleClickOutside = (event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setShowKebabMenu(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  // const getCaptableSlider = async () => {
  //   if (sliderValueRef.current === 1) {
  //     setSliderLoading(true)
  //   }
  //   try {
  //     const {
  //       data: { success, data },
  //     }: any = await getSliderData(companyId!)
  //     if (success) {
  //       setSliderData(data)
  //       const classIds: string[] = []
  //       for (const item of data) {
  //         if (item.type === 'securityClass') {
  //           classIds.push(item.id)
  //           if (item.isPresent) break
  //         }
  //       }
  //       setClassIds(classIds)
  //       sliderValueRef.current += 1
  //     }
  //   } catch (err) {
  //     console.log(err)
  //   } finally {
  //     setSliderLoading(false)

  //   }
  // }
  const getCaptableSlider = async () => {
    setIsLoading(true)
    try {
      const {
        data: { success, data },
      }: any = await getSliderData(companyId!)
      if (success) {
        setSliderData(data)
        const classIds: string[] = []
        for (const item of data) {
          if (item.type === 'securityClass') {
            classIds.push(item.id)
            if (item.isPresent) break
          }
        }
        setClassIds(classIds)
        sliderValueRef.current += 1
      }
    } catch (err) {
      console.log(err)
    }
  }


  useEffect(() => {
    getCaptableSlider()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  console.log(sliderValueRef, ' sliderValueRef')

  const getCaptableData = async () => {
    try {
      const payload: any = {
        classIds,
        scenarioIds,
      }
      const {
        data: { success, data },
      }: any = await getCaptable(companyId!, payload, search)
      if (success) {
        const transationswithsecurityclass: any[] = []

        data.securityClasses.forEach((securityClass: any) => {
          const transactions = securityClass.shareTransactions.map((transaction: any) => ({
            ...transaction,
            securityClass: securityClass.securityClass, // Add className to each transaction
          }))

          if (transactions.length > 0) {
            transationswithsecurityclass.push(...transactions)
          }
        })

        const shareholdersDTO = data.shareholdersDTO
        const transformedCaptable: Captable[] = shareholdersDTO.map(
          (shareholder: any, index: number) => {
            const shareholderTransactions = shareholder?.securityClass
              ? transationswithsecurityclass.filter(
                (transaction: any) =>
                  transaction.shareholderId === shareholder.shareholderId &&
                  shareholder.securityClass.some(
                    (secClass: any) => secClass.classId === transaction.securityClass.classId
                  )
              )
              : []

            return {
              id: index + 1,
              shareholderId: shareholder.shareholderId,
              shareholdings: shareholder.name || 'N/A',
              security_class: shareholder?.securityClass
                ? shareholder.securityClass.map((secClass: any) => ({
                  classId: secClass.classId,
                  className: secClass.className,
                  tagColor: secClass.tagColor,
                  classCode: secClass.classCode,
                }))
                : [],
              fully_diluted_shares: shareholder.investorFullyDilutedShares || 0,
              ownership: shareholder.ownershipPercentage || '0',
              profileImage: shareholder.profileImgId
                ? { id: shareholder.profileImgId, name: shareholder.profileImgName }
                : null,
              amount_invested: shareholder.shareholderTotalShareTransaction,
              shareTransations: shareholderTransactions,
              totalTransation: shareholderTransactions.length,
            }
          }
        )
        setShareholders(transformedCaptable)
        const totalFullyDilutedShares = shareholdersDTO.reduce(
          (sum: number, shareholder: any) => sum + (shareholder.investorFullyDilutedShares || 0),
          0
        )

        const totalAmountInvested = shareholdersDTO.reduce(
          (sum: number, shareholder: any) =>
            sum + (shareholder.shareholderTotalShareTransaction || 0),
          0
        )

        setSubtotals({
          totalTransactionCount: transationswithsecurityclass.length,
          totalFullyDilutedShares,
          totalAmountInvested,
        })
      }
    } catch (err) {
      console.log(err)
    } finally {
      // setSliderLoading(false)
      // setCaptableLoading(false)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (classIds.length > 0) {
      getCaptableData()
    }
  }, [classIds, scenarioIds, search]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <PageTitle
        breadcrumbs={CaptableManagementBreadCrumbs}
        description={formatMessage({ id: 'Cap Table' })}
      >
        {formatMessage({ id: 'Cap Table Management' })}
      </PageTitle>
      <div className='d-md-flex justify-content-between align-items-center px-6'>
        <h1 className='fs-4 fs-4'>{formatMessage({ id: 'Present & Projected Cap Table' })}</h1>
        <div className='d-flex gap-2 align-items-center justify-content-md-end justify-content-between mb-4'>
          <div className='d-flex align-items-center w-100'>
            <span className='svg-icon svg-icon-3 position-absolute ms-2'>
              <img src={searchIcon} alt='Search icon' />
            </span>
            <input
              type='text'
              data-kt-inbox-listing-filter='search'
              className='bg-body bg-white form-control form-control-flush ps-10 rounded-2 font-size-12 font-weight-400 py-3 border '
              placeholder='Search Cap Table'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div className='position-relative align-self-center'>
            <div
              className='p-3 cursor-pointer bg-white rounded-2 d-flex justify-content-center align-items-center border'
              onClick={() => {
                setShowKebabMenu(!showKebabMenu)
              }}
            >
              <img src={threeDots} alt='' width={18} height={18} />
            </div>
            {showKebabMenu && (
              <div
                className='card shadow rounded top-4 cursor-pointer z-index-1 position-absolute w-150px'
                style={{ top: '40px', right: 0 }}
                ref={dropdownRef}
              >
                <div className='border-bottom border-gray-300 border-bottom-2 p-2 dropdown-items w-100 bg-hover-secondary'>
                  <button
                    type='button'
                    className='m-0 border-0 bg-transparent text-primary font-size-12'
                  >
                    {formatMessage({ id: 'Export csv' })}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className='px-6'>
        <div className='w-100'>
          <InfoCard2
            title={formatMessage({ id: 'How to Manage Your Cap Table Efficiently?' })}
            desc={formatMessage({
              id: `${brandingConfig.brandName}’s Cap Table Management feature offers a seamless and organized approach to track your equity, project future ownership scenarios, and analyze management events.`,
            })}
            slug={brandingConfig.helpLinks.captableManagementDashboardOverview}
            className='w-100 mb-0'
          />
          {isLoading ? (
            <>
              <div className='d-none d-md-block'>
                <FundingSliderSkeleton />
              </div>
              <div className='d-md-none d-block'>
                <FundingDropdownSkeleton />
              </div>
              <div>
                <CaptableSkeleton />
              </div>
            </>
          ) : sliderData && sliderData.length === 0 ? (
            <NoDataPage />
          ) : (
            <>
              <div className='d-none d-md-block'>
                <FundingSlider
                  sliderData={sliderData}
                  setClassIds={setClassIds}
                  classIds={classIds}
                  setScenarioIds={setScenarioIds}
                  scenarioIds={scenarioIds}
                />
              </div>

              <div className='d-md-none d-block'>
                <FundingDropdown
                  sliderData={sliderData}
                  setClassIds={setClassIds}
                  classIds={classIds}
                  setScenarioIds={setScenarioIds}
                  scenarioIds={scenarioIds}
                />
              </div>

              <div>
                {shareholders && shareholders.length > 0 && (
                  <DataTableServerSideCaptable
                    shareholders={shareholders}
                    subtotals={subtotals}
                    captableLoading={captableLoading}
                  />
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default CaptableManagement
